// extracted by mini-css-extract-plugin
module.exports = {"list":"_9e1425b4d3--list--ohogd","item":"_9e1425b4d3--item--OCPBv","horizontal":"_9e1425b4d3--horizontal--ORBdV"};